import { render, staticRenderFns } from "./AccettazioneSsnStrutturaPresidioComponent.vue?vue&type=template&id=df2c5580&scoped=true"
import script from "./AccettazioneSsnStrutturaPresidioComponent.vue?vue&type=script&lang=js"
export * from "./AccettazioneSsnStrutturaPresidioComponent.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "df2c5580",
  null
  
)

export default component.exports